import React from 'react'

const Certificate = () => {
  return (
    <div>
      <div style={{marginBottom:'300px'}} >
              <p style={{color:'#bdbdbd', fontSize:'40px', lineHeight:'1px'}} >Company</p>
              <h1 style={{color:'#333333', fontSize:'40px',lineHeight:'1px'}}>Certifications</h1>
        </div>
    </div>
  )
}

export default Certificate
